declare const DEBUG_WITH_CONSOLE_LOG: boolean;

export const worker_id = DEBUG_WITH_CONSOLE_LOG ? self.crypto.randomUUID() : "None";

export function _debugOnConsole(msg?: any, ...data: any[]) {
  if (DEBUG_WITH_CONSOLE_LOG) {
    console.log(`[${new Date(Date.now()).toISOString()}] [${worker_id}] - ${msg}`, ...data);
  }
}
